// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__283Vl","controls":"styles_controls__2gRxT","charLimit":"styles_charLimit__1Veqa","input":"styles_input__16D4V","send":"styles_send__4OzzT"};